function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.042 6.344V4.376H3.958v1.968c0 .26-.14.497-.356.602A.546.546 0 013.365 7a.566.566 0 01-.405-.175L.19 3.981A.693.693 0 010 3.5a.69.69 0 01.19-.48L2.96.176a.554.554 0 01.642-.12c.216.103.356.34.356.6v1.97h11.084V.656c0-.26.14-.497.356-.602a.554.554 0 01.642.121l2.77 2.844c.121.125.19.299.19.481a.695.695 0 01-.19.481l-2.77 2.844a.565.565 0 01-.405.175.558.558 0 01-.237-.054.662.662 0 01-.356-.602z",
  fill: "#333"
});

function SvgIconPowersDist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 7,
    fill: "none"
  }, props), _ref);
}

export default SvgIconPowersDist;